var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showListagem
        ? _c("app-divider", { attrs: { label: "Atividades" } })
        : _vm._e(),
      _vm.destinacaoUsoImovel.culturasPermanentes &&
      _vm.destinacaoUsoImovel.culturasPermanentes.length > 0
        ? _c(
            "app-collapse-child",
            {
              class:
                _vm.compararDestinacaoUsoImovel &&
                _vm.compararDestinacaoUsoImovel.mudouCulturaPermanente
                  ? "text-collapse"
                  : "",
              attrs: {
                title: "Culturas permanentes",
                name: "culturasPermanentes"
              }
            },
            [
              _c(
                "el-table",
                {
                  attrs: { data: _vm.destinacaoUsoImovel.culturasPermanentes }
                },
                [
                  _c("template", { slot: "empty" }, [
                    _vm._v("Nenhuma cultura permanente cadastrada.")
                  ]),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaPermanente &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaPermanente
                        .mudouTipo
                        ? "text"
                        : "",
                    attrs: {
                      prop: "descTipo",
                      label: "Tipo",
                      formatter: _vm.setTipoAtividadeProducao
                    }
                  }),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaPermanente &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaPermanente
                        .mudouArea
                        ? "text"
                        : "",
                    attrs: {
                      prop: "area",
                      label: _vm.isBahia ? "Área estimada" : "Área",
                      formatter: _vm.formatAreaHectare
                    }
                  }),
                  _vm.produtividade
                    ? _c("el-table-column", {
                        class:
                          _vm.compararDestinacaoUsoImovel &&
                          _vm.compararDestinacaoUsoImovel
                            .mudouCulturaPermanente &&
                          _vm.compararDestinacaoUsoImovel.mudouCulturaPermanente
                            .mudouProdutividade
                            ? "text"
                            : "",
                        attrs: {
                          prop: "produtividade",
                          label: "Produtividade",
                          width: "180",
                          formatter: _vm.formatProdutividade
                        }
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm.destinacaoUsoImovel.culturasTemporarias &&
      _vm.destinacaoUsoImovel.culturasTemporarias.length > 0
        ? _c(
            "app-collapse-child",
            {
              class:
                _vm.compararDestinacaoUsoImovel &&
                _vm.compararDestinacaoUsoImovel.mudouCulturaTemporaria
                  ? "text-collapse"
                  : "",
              attrs: {
                title: "Culturas temporárias",
                name: "culturasTemporarias"
              }
            },
            [
              _c(
                "el-table",
                {
                  attrs: { data: _vm.destinacaoUsoImovel.culturasTemporarias }
                },
                [
                  _c("template", { slot: "empty" }, [
                    _vm._v("Nenhuma cultura temporária cadastrada.")
                  ]),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaTemporaria &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaTemporaria
                        .mudouTipo
                        ? "text"
                        : "",
                    attrs: {
                      prop: "tipo",
                      label: "Tipo",
                      formatter: _vm.setTipoAtividadeProducao
                    }
                  }),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaTemporaria &&
                      _vm.compararDestinacaoUsoImovel.mudouCulturaTemporaria
                        .mudouArea
                        ? "text"
                        : "",
                    attrs: {
                      prop: "area",
                      label: _vm.isBahia ? "Área estimada" : "Área",
                      formatter: _vm.formatAreaHectare
                    }
                  }),
                  _vm.produtividade
                    ? _c("el-table-column", {
                        class:
                          _vm.compararDestinacaoUsoImovel &&
                          _vm.compararDestinacaoUsoImovel
                            .mudouCulturaTemporaria &&
                          _vm.compararDestinacaoUsoImovel.mudouCulturaTemporaria
                            .mudouProdutividade
                            ? "text"
                            : "",
                        attrs: {
                          prop: "produtividade",
                          label: "Produtividade",
                          width: "200",
                          formatter: _vm.formatProdutividade
                        }
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm.destinacaoUsoImovel.criacoes &&
      _vm.destinacaoUsoImovel.criacoes.length > 0
        ? _c(
            "app-collapse-child",
            { attrs: { title: "Criações", name: "criacoes" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.destinacaoUsoImovel.criacoes } },
                [
                  _c("template", { slot: "empty" }, [
                    _vm._v("Nenhuma criação cadastrada.")
                  ]),
                  _c("el-table-column", {
                    attrs: {
                      prop: "tipo",
                      label: "Tipo",
                      formatter: _vm.setTipoAtividadeProducao
                    }
                  }),
                  _c("el-table-column", {
                    class:
                      _vm.compararDestinacaoUsoImovel &&
                      _vm.compararDestinacaoUsoImovel.mudouEdificacoes &&
                      _vm.compararDestinacaoUsoImovel.mudouEdificacoes.mudouArea
                        ? "text"
                        : "",
                    attrs: {
                      prop: "numeroCabecas",
                      label: "Número de cabeças",
                      formatter: _vm.formatNumCabecas
                    }
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm.destinacaoUsoImovel.benfeitorias &&
      _vm.destinacaoUsoImovel.benfeitorias.length > 0
        ? _c(
            "app-collapse-child",
            { attrs: { title: "Benfeitorias", name: "benfeitorias" } },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.destinacaoUsoImovel.benfeitorias } },
                [
                  _c("template", { slot: "empty" }, [
                    _vm._v("Nenhuma benfeitoria cadastrada.")
                  ]),
                  _c("el-table-column", {
                    attrs: {
                      prop: "tipo",
                      label: "Tipo",
                      formatter: _vm.setTipoAtividadeProducao
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "area",
                      label: _vm.isBahia ? "Área estimada" : "Área",
                      formatter: _vm.formatArea
                    }
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f1c06cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f1c06cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesAtividades.vue
// module id = null
// module chunks = 